import { render, staticRenderFns } from "./ProductTitle.vue?vue&type=template&id=97e57ba4&scoped=true&"
import script from "./ProductTitle.vue?vue&type=script&lang=js&"
export * from "./ProductTitle.vue?vue&type=script&lang=js&"
import style0 from "./ProductTitle.vue?vue&type=style&index=0&id=97e57ba4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e57ba4",
  null
  
)

export default component.exports